$(function(){
  $(".fileuplaodcv").AjaxFileUpload({
    onChange: function(filename){
        $(this).closest('.fileupload').find(".btn-file").addClass("uploading");
    },
    onComplete: function(filename, response) {

      if (response == 'FAILED') { // לא תמיד צריך את זה
        $(this).closest('.fileupload').find(".fileuplaodcvupdate").val(response)
        $(this).closest('.fileupload').find(".txt_up").text('Document not added');
        $(this).closest('.fileupload').find(".btn-file").removeClass("uploading");

      } else {
        $(this).closest('.fileupload').find(".fileuplaodcvupdate").val(response)
        $(this).closest('.fileupload').find(".txt_up").text(filename);
        $(this).closest('.fileupload').find(".btn-file").removeClass("uploading");
      }
       
      }
  });
});






// $(document).ready(function() {
//   $('.js_dupliacate').on('click', function() {
//       let $duplicatorOpen = $(this).closest('.duplicator_open');
//       let $originalContent = $duplicatorOpen.find('.duplicator_content_wrap .duplicator_content').first();
//       let $clonedContent = $originalContent.clone();
//       let currentCount = $duplicatorOpen.find('.duplicator_content_wrap .duplicator_content').length + 1;
//       $originalContent.find('.numbering_duplicate').remove();
//       if ($originalContent.length > 0) {
//           $originalContent.prepend('<span class="numbering_duplicate">1</span>');
//       }
//       $clonedContent.find('input, textarea').val('');
//       $clonedContent.find('.numbering_duplicate').remove();
//       $clonedContent.prepend('<span class="numbering_duplicate">' + currentCount + '</span>');
//       $duplicatorOpen.find('.duplicator_content_wrap').append($clonedContent);
//       $clonedContent.addClass('to_be_added');
//       setTimeout(function() {
//           $clonedContent.removeClass('to_be_added');
//       }, 300);
//   });
//   $(document).on('click', '.numbering_duplicate', function() {
//       let $duplicatorOpen = $(this).closest('.duplicator_open');
//       let $contentWrap = $duplicatorOpen.find('.duplicator_content_wrap');
//       if ($contentWrap.find('.duplicator_content').length > 1) {
//           let $contentToRemove = $(this).closest('.duplicator_content');
//           let confirmation = confirm("Are you sure you want to delete this item?");
//           if (confirmation) {
//               $contentToRemove.addClass('to_be_deleted');
//               setTimeout(function() {
//                   $contentToRemove.remove();
//                   $duplicatorOpen.find('.duplicator_content_wrap .duplicator_content').each(function(index) {
//                       $(this).find('.numbering_duplicate').remove();
//                       $(this).prepend('<span class="numbering_duplicate">' + (index + 1) + '</span>');
//                   });
//               }, 700);
//           }
//       }
//   });
// });


$(document).ready(function () {
  let uniqueId = 5000; // Start the unique ID counter

  $('.js_dupliacate').on('click', function () {
    let $duplicatorOpen = $(this).closest('.duplicator_open');
    let $originalContent = $duplicatorOpen.find('.duplicator_content_wrap .duplicator_content').first();
    let $clonedContent = $originalContent.clone();
    let currentCount = $duplicatorOpen.find('.duplicator_content_wrap .duplicator_content').length + 1;

    // Add numbering to the original content
    $originalContent.find('.numbering_duplicate').remove();
    if ($originalContent.length > 0) {
      $originalContent.prepend('<span class="numbering_duplicate">1</span>');
    }

    // Assign a unique shared ID for this duplicated content
    let newSharedId = uniqueId++;
    $clonedContent.find('input, textarea, select').each(function () {
      let name = $(this).attr('name');
      // Modify the name attribute for unique IDs
      if (name && name.startsWith('db[duplicator]')) {
        // Use regex to capture parts of the name
        let parts = name.match(/^db\[duplicator]\[(\d+)]\[(\d+)]\[(.+)]$/);
        if (parts) {
          let randomNumber = parts[1]; // Extract the first random number
          let oldSharedId = parts[2]; // Extract the current shared ID
          let lastPart = parts[3];    // Extract the last dynamic part
          // Update the name attribute with the new structure
          $(this).attr('name', `db[duplicator][${randomNumber}][${newSharedId}][${lastPart}]`);
        }
      }

      // Retain value of duplicator_title, clear others
      if (name && name.includes('duplicator_title')) {
        return; // Skip resetting value for duplicator_title
      }

      // Clear the value of inputs and textareas
      if ($(this).is('input, textarea')) {
        $(this).val('');
      }

      // Reset selects to the default option (optional)
      if ($(this).is('select')) {
        $(this).prop('selectedIndex', 0);
      }
    });

    // Update numbering in the cloned content
    $clonedContent.find('.numbering_duplicate').remove();
    $clonedContent.prepend('<span class="numbering_duplicate">' + currentCount + '</span>');

    // Append cloned content
    $duplicatorOpen.find('.duplicator_content_wrap').append($clonedContent);
    $clonedContent.addClass('to_be_added');

    setTimeout(function () {
      $clonedContent.removeClass('to_be_added');
    }, 300);
  });

  // Handle delete functionality
  $(document).on('click', '.numbering_duplicate', function () {
    let $duplicatorOpen = $(this).closest('.duplicator_open');
    let $contentWrap = $duplicatorOpen.find('.duplicator_content_wrap');
    if ($contentWrap.find('.duplicator_content').length > 1) {
      let $contentToRemove = $(this).closest('.duplicator_content');
      let confirmation = confirm("Are you sure you want to delete this item?");
      if (confirmation) {
        $contentToRemove.addClass('to_be_deleted');
        setTimeout(function () {
          $contentToRemove.remove();
          $duplicatorOpen.find('.duplicator_content_wrap .duplicator_content').each(function (index) {
            $(this).find('.numbering_duplicate').remove();
            $(this).prepend('<span class="numbering_duplicate">' + (index + 1) + '</span>');
          });
        }, 700);
      }
    }
  });
});
